import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import {
  Button,
  TextField,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
  Box,
  Grid,
  Paper,
  Collapse,  
  Divider,   
  IconButton, 
} from "@mui/material";
//added for new multiple locations feature
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import "./Style.css";
import { SPECIALITY_OPTIONS, normalizeSpecialities } from "../constants/specialities";
const envVariable = require("../EnvironmentVariables.json");
import { REGISTER_SUBTITLE, REGISTER_TITLE } from "../branding";

const emptyLocation = () => ({
  nickname: "",
  phone: "",
  address1: "",
  address2: "",
  zip: "",
  city: "",
  state: "",
  country: "USA",
  latitude: "0.0",
  longitude: "0.0",
  is_primary: 0, // backend will enforce one primary; we set first one to 1 on submit
  specialities: [],
});

function Register() {
  const navigate = useNavigate();

  const MAX_LOCATIONS = 5;
  const [submitError, setSubmitError] = useState("");

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    personalEmail: "",
    password: "",
    confirmpassword: "",
    sconame: "",
    personalPhone: "",
    createMechanicProfile: true,
    specialities: [],
    upload_file: null,

    locations: [{ ...emptyLocation(), nickname: "Primary", is_primary: 1 }],

    /*phone: "",
    address1: "",
    address2: "",
    zip: "",
    city: "",
    state: "", removed to implement this is in locations DB table*/
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubmitError("");
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setSubmitError("");
    setFormData({ ...formData, upload_file: e.target.files[0] });
  };

  // NEW: update location fields
  const handleLocationChange = (idx, field, value) => {
    setSubmitError("");
    setFormData((p) => {
      const next = [...p.locations];
      next[idx] = { ...next[idx], [field]: value };
      return { ...p, locations: next };
    });
  };

  const handleLocationSpecialityChange = (idx, specialityId, checked) => {
    setSubmitError("");
    setFormData((prev) => {
      const next = [...prev.locations];
      const current = normalizeSpecialities(next[idx]?.specialities || []);
      next[idx] = {
        ...next[idx],
        specialities: checked
          ? normalizeSpecialities([...current, specialityId])
          : current.filter((item) => item !== specialityId),
      };
      return { ...prev, locations: next };
    });
  };

  // NEW: add/remove locations (Location 2+ appear only when user clicks Add)
  const addLocation = () => {
  if (formData.locations.length >= MAX_LOCATIONS) {
      setSubmitError("Maximum of 5 locations allowed.");
      return;
    }

    setSubmitError("");
    setFormData((p) => ({
      ...p,
      locations: [...p.locations, emptyLocation()],
    }));
  };

  const removeLocation = (idx) => {
    setSubmitError("");
    setFormData((p) => {
      if (p.locations.length <= 1) return p;
      const next = p.locations.filter((_, i) => i !== idx);
  
      if (!next.some((l) => Number(l.is_primary) === 1)) {
        next[0] = { ...next[0], nickname: next[0].nickname || "Primary", is_primary: 1 };
      }
      return { ...p, locations: next };
    });
  };

  const validateBeforeSubmit = () => {
    if (formData.password !== formData.confirmpassword) {
      alert("Passwords do not match.");
      return false;
    }

    // Validate each location
    for (let i = 0; i < formData.locations.length; i++) {
      const loc = formData.locations[i];

      if (!loc.phone || String(loc.phone).replace(/\D/g, "").length !== 10) {
        alert(`Location ${i + 1}: phone must be 10 digits.`);
        return false;
      }
      if (!loc.address1) {
        alert(`Location ${i + 1}: Address Line 1 is required.`);
        return false;
      }
      if (!loc.zip || String(loc.zip).length < 5) {
        alert(`Location ${i + 1}: ZIP is required.`);
        return false;
      }
      if (!loc.city) {
        alert(`Location ${i + 1}: City is required.`);
        return false;
      }
      if (!loc.state) {
        alert(`Location ${i + 1}: State is required.`);
        return false;
      }
    }

    if (!formData.upload_file) {
      alert("Please upload an image of your business.");
      return false;
    }

    return true;
  }; //end of new location functions

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");
  
    if (!validateBeforeSubmit()) return;
    const data = new FormData();
  
    for (const key in formData) {
      if (key !== "upload_file" && key !== "locations") {
        data.append(key, formData[key]);
      }
    }

    const normalizedLocations = formData.locations.map((l, idx) => ({
      ...l,
      phone: String(l.phone).replace(/\D/g, ""),
      zip: String(l.zip),
      is_primary: idx === 0 ? 1 : 0,
      nickname: idx === 0 ? (l.nickname || "Primary") : (l.nickname || ""),
      country: l.country || "USA",
      latitude: l.latitude ?? "0.0",
      longitude: l.longitude ?? "0.0",
      specialities: normalizeSpecialities(l.specialities),
    }));
    data.append("locations", JSON.stringify(normalizedLocations));
  
    if (formData.upload_file) {
      data.append("upload_file", formData.upload_file);
    }
  
    try {
      const response = await fetch(envVariable.serverId + "/SCO/Register.php", {
        method: "POST",
        body: data,
      });
  
      const result = await response.json();
  
      if (result.status === "Success") {
        setSubmitError("");
        navigate("/login");
      } else {
        setSubmitError(result.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      setSubmitError("Unable to register right now. Please try again.");
    }
  };

  return (
    <>
      <Navbar />
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <Paper sx={{ p: 4, width: "100%", maxWidth: 800 }}>
          <Typography variant="h4" gutterBottom align="center">
            {REGISTER_TITLE}
          </Typography>
          <Typography variant="body2" align="center" gutterBottom>
            {REGISTER_SUBTITLE}
          </Typography>
          <Typography variant="body2" align="center" gutterBottom>
            Have an account? <Link to="/login">Sign in</Link>
          </Typography>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Service Center Name"
                  name="sconame"
                  value={formData.sconame}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="First Name"
                  name="fname"
                  value={formData.fname}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Last Name"
                  name="lname"
                  value={formData.lname}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="SC Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Personal Email"
                  name="personalEmail"
                  type="email"
                  value={formData.personalEmail}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Confirm Password"
                  name="confirmpassword"
                  type="password"
                  value={formData.confirmpassword}
                  onChange={handleChange}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Personal Phone Number"
                  name="personalPhone"
                  type="number"
                  value={formData.personalPhone}
                  onChange={handleChange}
                  inputProps={{ maxLength: 12 }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="SC Phone Number"
                  name="phone"
                  type="number"
                  value={formData.phone}
                  onChange={handleChange}
                  inputProps={{ maxLength: 12 }}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(formData.createMechanicProfile)}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          createMechanicProfile: e.target.checked,
                        }))
                      }
                    />
                  }
                  label="Create a mechanic profile for this SCO account"
                />
              </Grid>

              {/* ---------- LOCATIONS ---------- */}
              <Grid item xs={12}>
                <Typography variant="h6">Location Information</Typography>
                <Typography variant="body2" color="text.secondary">
                  Location 1 is your primary location. Click “Add another location” to add more.
                </Typography>
              </Grid>

              {formData.locations.map((loc, idx) => {
                const isPrimary = idx === 0;

                return (
                  <Grid item xs={12} key={idx}>
                    <Paper variant="outlined" sx={{ p: 2 }}>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle1">
                          {isPrimary ? "Primary Location" : `Location ${idx + 1}`}
                        </Typography>
                        {!isPrimary && (
                          <IconButton onClick={() => removeLocation(idx)} aria-label="remove location">
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Box>

                      <Divider sx={{ my: 2 }} />

                      {/* Primary always visible; secondary “dropdown-like” */}
                      <Collapse in={true}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Location Nickname (Optional)"
                              value={loc.nickname}
                              onChange={(e) => handleLocationChange(idx, "nickname", e.target.value)}
                              inputProps={{ maxLength: 60 }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              required
                              label="SC Phone Number"
                              type="tel"
                              value={loc.phone}
                              onChange={(e) => handleLocationChange(idx, "phone", e.target.value)}
                              inputProps={{ maxLength: 12 }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              required
                              label="Address Line 1"
                              value={loc.address1}
                              onChange={(e) => handleLocationChange(idx, "address1", e.target.value)}
                              inputProps={{ maxLength: 100 }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Address Line 2 (Optional)"
                              value={loc.address2}
                              onChange={(e) => handleLocationChange(idx, "address2", e.target.value)}
                              inputProps={{ maxLength: 100 }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              required
                              label="ZIP"
                              type="number"
                              value={loc.zip}
                              onChange={(e) => handleLocationChange(idx, "zip", e.target.value)}
                              inputProps={{ maxLength: 10 }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              required
                              label="City"
                              value={loc.city}
                              onChange={(e) => handleLocationChange(idx, "city", e.target.value)}
                              inputProps={{ maxLength: 50 }}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              required
                              label="State"
                              value={loc.state}
                              onChange={(e) => handleLocationChange(idx, "state", e.target.value)}
                              inputProps={{ maxLength: 50 }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <FormControl component="fieldset">
                              <Typography variant="subtitle1">Location Features</Typography>
                              <FormGroup row>
                                {SPECIALITY_OPTIONS.map((option) => (
                                  <FormControlLabel
                                    key={`${idx}-${option.id}`}
                                    control={
                                      <Checkbox
                                        checked={(loc.specialities || []).includes(option.id)}
                                        onChange={(e) =>
                                          handleLocationSpecialityChange(idx, option.id, e.target.checked)
                                        }
                                      />
                                    }
                                    label={option.label}
                                  />
                                ))}
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Collapse>
                    </Paper>
                  </Grid>
                );
              })}

              <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<AddIcon />}
                onClick={addLocation}
                disabled={formData.locations.length >= MAX_LOCATIONS}
              >
                {formData.locations.length >= MAX_LOCATIONS
                  ? "Maximum of 5 locations reached"
                  : "Add another location"}
              </Button>
              </Grid>
              
              <Grid item xs={12}>
                <Button variant="contained" component="label" fullWidth>
                  Upload an Image of your Business
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>
                {formData.upload_file && <Typography>Selected file: {formData.upload_file.name}</Typography>}
              </Grid>
              {submitError && (
                <Grid item xs={12}>
                  <Typography color="error" fontWeight={600} align="center">
                    {submitError}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
      <Footer />
    </>
  );
}

export default Register;
